import React from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';
import { Trans } from 'react-i18next';

import { SERVICE_FEATURES_DATA } from './data/serviceFeaturesData';
import { Divider } from '../../../shared/components/Divider';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles({
  flexContainer: {
    display: 'flex',
  },

  imgStyle: {
    width: 60,
    height: 60,
    marginRight: 30,
  },
});

export const ServiceFeatures = () => {
  const styles = useStyle();
  return SERVICE_FEATURES_DATA.map(({ title, subTitle, icon }, i) => (
    <React.Fragment key={i}>
      <Box className={styles.flexContainer}>
        <img src={icon} alt="#" className={styles.imgStyle} />
        <Box>
          <Text variant="h4" labelColor="primary">
            <Trans>{title}</Trans>
          </Text>
          <Text variant="subtitle1">
            <Trans>{subTitle}</Trans>
          </Text>
        </Box>
      </Box>
      <Divider height={50} />
    </React.Fragment>
  ));
};
